import { createCDItemsAsync } from 'API/order/escrow/EscrowAPI';
import { createAsyncSlice } from 'store/createAsyncSlice';

export const { slice: addCDItemsSlice, asyncAction: addCDItemsAction } = createAsyncSlice(
  'addCDItemsSlice',
  createCDItemsAsync
);
